module.exports = __webpack_public_path__ + "752b2f2fc4fb62a78f5771a2d2fbdb31.svg";